import { axios } from "@axios";

export type PrivacyPolicy = {
  uuid: string;
  title: string;
  content: string;
  createdAt: string;
  updatedAt: string;
};

export type PrivacyPolicyResponse = {
  statusCode: number;
  data: PrivacyPolicy | null;
  message: string;
};

export const getPrivacyPolicy = (): Promise<PrivacyPolicyResponse> => {
  return axios.get(`/admin/privacy-policy`);
};
